var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Close, Edit, ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
import { Backdrop, Chip, CircularProgress, Divider, Grid, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { ReactComponent as RefreshIcon } from '../../../assets/images/refreshIcon.svg';
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import InfiniteScroll from "../../../builderPackage/components/infiniteScroll/infiniteScroll";
import { MuiButton, MuiStack } from "../../../components";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import ListPageHeaderComponent from "../../../components/templates/listPageHeaderComponent";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { resetState, setReducerState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { getStatusColor } from "../../../theme/statusColors";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, isLoadingState } from "../../../utils/utils";
import { FilterComponent } from "../components/filterComponent";
import { spareIssuePagingAPICall } from "../services/apiCalls";
import { APIKeys, defaultState, SpareIssuesKeys } from "../services/entity";
var SpareIssues = function () {
    var _getLocalStorageItem, _filterValue$Warehous, _filterValue$ServiceA, _filterValue$Technici, _filterValue$StartDoc, _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _crud$SpareIssuesKeys3, _crud$SpareIssuesKeys4;
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState(false), isCardView = _a[0], setIsCardView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var UserProfileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var listVariants = ["My Spare Issue", "All Spare Issue"];
    var _c = useState(listVariants[1]), selectedListVariant = _c[0], setSelectedListVariant = _c[1];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    useEffect(function () {
        if (isMobile)
            setIsCardView(true);
        if (!isMobile)
            setIsCardView(false);
    }, [isMobile]);
    var request = _objectSpread(_objectSpread({}, defaultState), {}, {
        // IdentityId: UserProfileData?.data?.IdentityId ?? undefined,
        Branches: [(_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId],
        Status: filterValue === null || filterValue === void 0 ? void 0 : filterValue.Status,
        WarehouseId: (_filterValue$Warehous = filterValue === null || filterValue === void 0 ? void 0 : filterValue.WarehouseId) !== null && _filterValue$Warehous !== void 0 ? _filterValue$Warehous : undefined,
        ServiceAdviserId: (_filterValue$ServiceA = filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceAdvisorId) !== null && _filterValue$ServiceA !== void 0 ? _filterValue$ServiceA : undefined,
        TechnicianId: (_filterValue$Technici = filterValue === null || filterValue === void 0 ? void 0 : filterValue.TechnicianId) !== null && _filterValue$Technici !== void 0 ? _filterValue$Technici : undefined,
        FromDate: (_filterValue$StartDoc = filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate) !== null && _filterValue$StartDoc !== void 0 ? _filterValue$StartDoc : undefined,
        ToDate: filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate : filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate : undefined
    });
    var hasMore = !crud[SpareIssuesKeys.Paging] || ((_crud$SpareIssuesKeys = crud[SpareIssuesKeys.Paging]) === null || _crud$SpareIssuesKeys === void 0 || (_crud$SpareIssuesKeys = _crud$SpareIssuesKeys.data) === null || _crud$SpareIssuesKeys === void 0 ? void 0 : _crud$SpareIssuesKeys.length) < ((_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.Paging]) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.TotalCount);
    var cardElements = [{
            type: FormItemTypes.CardComponent,
            name: 'root-card',
            columnSize: 12,
            contentProps: {
                spacing: 0
            },
            sx: {
                p: 1.5
            },
            setFieldProps: function (formValues, currValue, field) {
                return {
                    type: this.type,
                    onClick: function (e) {
                        console.log(formValues.id);
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: 'title-containter',
                    spacing: 0,
                    columnSize: true,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentNo',
                            fontWeight: 'strong',
                            component: Link,
                            sx: {
                                cursor: 'pointer',
                                textDecoration: 'none'
                            },
                            variant: 'button',
                            columnSize: 12,
                            setFieldProps: function (formValues) {
                                return {
                                    type: FormItemTypes.Typography,
                                    onClick: function () {
                                        handleRowClick(formValues);
                                    }
                                };
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'RegistrationNo',
                            color: 'text.secondary',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.Chip,
                    name: 'StatusName',
                    columnSize: 0,
                    size: 'small',
                    shape: 'rounded',
                    setFieldProps: function (formValues, currValue) {
                        return _objectSpread({
                            type: this.type
                        }, getStatusColor(currValue));
                    }
                }, {
                    type: FormItemTypes.IconButton,
                    name: 'CTA',
                    color: 'secondary',
                    size: 'small',
                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                        color: "secondary"
                    }),
                    columnSize: 0,
                    onClick: function (e) {
                        e.stopPropagation();
                    }
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: true,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    detailPanelProps: {
                        spacing: 0,
                        p: 1.5,
                        rowSpacing: 1
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'RequestedDateTime',
                            label: 'Document date: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            valueGetter: function (formValues, field) {
                                var currValue = formValues === null || formValues === void 0 ? void 0 : formValues[this.name];
                                if (currValue)
                                    return dateFormate(currValue);
                                else
                                    return '-';
                            },
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'JobCardNo',
                            label: 'Job card number: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'VinNo',
                            label: 'VIN: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ServiceAdvisorName',
                            label: 'Service advisor: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'TechnicianName',
                            label: 'Technician: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            }
                        }],
                    columnSize: 12,
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: this.type,
                            containerProps: {
                                my: currValue ? 1.5 : 0
                            }
                        };
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    justifyContent: 'end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            sx: {
                                p: 0.5,
                                fontSize: 'sm'
                            },
                            onClick: function (e) {
                                e.stopPropagation();
                            },
                            setFormState: function (formValues) {
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['Open', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            }
                        }]
                }]
        }];
    var customActionColumns = [{
            field: 'DocumentNo',
            headerName: 'Document Number',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.DocumentNo ? "".concat(row === null || row === void 0 ? void 0 : row.DocumentNo) : '-'; },
            minWidth: 200
        }, {
            field: 'RequestedDateTime',
            headerName: 'Document date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RequestedDateTime ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.RequestedDateTime)) : '-'; },
            minWidth: 200
        }, {
            field: 'JobCardNo',
            headerName: 'Job card No.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.JobCardNo ? "".concat(row === null || row === void 0 ? void 0 : row.JobCardNo) : '-'; },
            minWidth: 200
        }, {
            field: 'VinNo',
            headerName: 'VIN.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.VinNo ? "".concat(row === null || row === void 0 ? void 0 : row.VinNo) : '-'; },
            minWidth: 200
        }, {
            field: 'RegistrationNo',
            headerName: 'Registration No.',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.RegistrationNo ? "".concat(row === null || row === void 0 ? void 0 : row.RegistrationNo) : '-'; },
            minWidth: 200
        }, {
            field: 'FloorSupervisorName',
            headerName: 'Floor Supervisor',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.FloorSupervisorName ? "".concat(row === null || row === void 0 ? void 0 : row.FloorSupervisorName) : '-'; },
            minWidth: 200
        }, {
            field: 'TechnicianName',
            headerName: 'Technician',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TechnicianName ? "".concat(row === null || row === void 0 ? void 0 : row.TechnicianName) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalPartsCount',
            headerName: 'Total Parts Count',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalPartsCount ? "".concat(row === null || row === void 0 ? void 0 : row.TotalPartsCount) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalAvailableQuantity',
            headerName: 'Total Parts Quantity',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalAvailableQuantity ? "".concat(row === null || row === void 0 ? void 0 : row.TotalAvailableQuantity) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalIssuedQuantity',
            headerName: 'Total Issued Quantity',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalIssuedQuantity ? "".concat(row === null || row === void 0 ? void 0 : row.TotalIssuedQuantity) : '-'; },
            minWidth: 200
        }, {
            field: 'ProductName',
            headerName: 'Product Name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ProductName ? "".concat(row === null || row === void 0 ? void 0 : row.ProductName) : '-'; },
            minWidth: 200
        }, {
            field: 'BranchName',
            headerName: 'Branch',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.BranchName ? "".concat(row === null || row === void 0 ? void 0 : row.BranchName) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalAmount',
            headerName: 'Total Amount',
            valueFormatter: function (val, row) {
                var _Number;
                return val ? (_Number = Number(val)) === null || _Number === void 0 ? void 0 : _Number.toFixed(2) : '-';
            },
            minWidth: 200
        }, {
            field: 'ServiceAdvisorName',
            headerName: 'Service Advisor',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ServiceAdvisorName ? "".concat(row === null || row === void 0 ? void 0 : row.ServiceAdvisorName) : '-'; }
        }, {
            field: 'IssuedBy',
            headerName: 'Issued By',
            valueFormatter: function (value, row) {
                var _row$CreatedByGivenNa, _row$CreatedByFamilyN;
                return row !== null && row !== void 0 && row.CreatedByGivenName || row !== null && row !== void 0 && row.CreatedByFamilyName ? "".concat((_row$CreatedByGivenNa = row === null || row === void 0 ? void 0 : row.CreatedByGivenName) !== null && _row$CreatedByGivenNa !== void 0 ? _row$CreatedByGivenNa : '', " ").concat((_row$CreatedByFamilyN = row === null || row === void 0 ? void 0 : row.CreatedByFamilyName) !== null && _row$CreatedByFamilyN !== void 0 ? _row$CreatedByFamilyN : '') : '';
            }
        }, {
            field: 'StatusName',
            headerName: 'Status',
            width: 110,
            renderCell: function (params) { /*#__PURE__*/ return React.createElement(Chip, _extends({
                label: (params === null || params === void 0 ? void 0 : params.value) || '-',
                size: "small"
            }, getStatusColor((params === null || params === void 0 ? void 0 : params.value) || ''), {
                sx: {
                    padding: '2px 8px',
                    borderRadius: '6px'
                }
            })); },
            minWidth: 200
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            width: 120,
            getActions: function (params) {
                var getIcon = function (name) {
                    switch (name) {
                        case 'Edit':
                            return /*#__PURE__*/ React.createElement(Edit, null);
                        case 'Cancel':
                            return /*#__PURE__*/ React.createElement(Close, null);
                        case 'CreateSpareReturn':
                            return /*#__PURE__*/ React.createElement(RefreshIcon, null);
                        default:
                            return /*#__PURE__*/ React.createElement(React.Fragment, null);
                    }
                };
                return storedMenuFeatures === null || storedMenuFeatures === void 0 ? void 0 : storedMenuFeatures.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    showInMenu: true,
                    onClick: function () {
                        if ((data === null || data === void 0 ? void 0 : data.Name) == 'Edit') {
                            var _params$row;
                            handleRowClick(params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.id);
                        }
                        else if ((data === null || data === void 0 ? void 0 : data.Name) === "CreateSpareReturn") {
                            navigate('/spare-issue-return');
                        }
                    }
                }); });
            }
        }];
    var handleRowClick = function (id) {
        dispatch(resetState(APIKeys));
        navigate("/spareIssues/createSpareIssues/".concat(id, "?mode=edit"));
    };
    var onClickCreateModule = function () {
        navigate("/spareIssues/createSpareIssues?mode=add");
    };
    var handleSelectMenu = function (listVariant) { return __awaiter(void 0, void 0, void 0, function () {
        var _UserProfileData$data;
        return __generator(this, function (_a) {
            if (listVariant === "My Spare Issue")
                spareIssuePagingAPICall({
                    request: _objectSpread(_objectSpread({}, request), {}, {
                        IdentityId: UserProfileData === null || UserProfileData === void 0 || (_UserProfileData$data = UserProfileData.data) === null || _UserProfileData$data === void 0 ? void 0 : _UserProfileData$data.IdentityId
                    })
                });
            if (listVariant === "All Spare Issue")
                spareIssuePagingAPICall({
                    request: _objectSpread({}, request)
                });
            dispatch(setReducerState({
                key: SpareIssuesKeys.Paging,
                value: true
            }));
            setSelectedListVariant(listVariant);
            return [2 /*return*/];
        });
    }); };
    console.log("what is data : ", crud === null || crud === void 0 || (_crud$SpareIssuesKeys3 = crud[SpareIssuesKeys.Paging]) === null || _crud$SpareIssuesKeys3 === void 0 ? void 0 : _crud$SpareIssuesKeys3.data);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isMobile && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        paddingLeft: 1,
        borderBottom: '1px solid #DEE4EB'
    }, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        sx: {
            width: "100%",
            paddingX: 1
        },
        tabVariant: "standard",
        showTabIndicator: true,
        bgColorApply: true
    })), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            padding: {
                sm: '0px 8px 0px 24px !important'
            }
        }
    }, /*#__PURE__*/ React.createElement(ListPageHeaderComponent, {
        handleClickFilterIcon: function () { return setFilterOpen(true); },
        selectedMenuItem: selectedListVariant,
        menus: listVariants,
        onSelectMenu: function (listVariant) { return handleSelectMenu(listVariant); },
        activeView: selectedListVariant,
        onToggleView: function (view) {
            var _UserProfileData$data2;
            setIsCardView(view === "grid");
            if (selectedListVariant === "My Spare Issue")
                spareIssuePagingAPICall({
                    request: _objectSpread(_objectSpread({}, request), {}, {
                        IdentityId: UserProfileData === null || UserProfileData === void 0 || (_UserProfileData$data2 = UserProfileData.data) === null || _UserProfileData$data2 === void 0 ? void 0 : _UserProfileData$data2.IdentityId
                    })
                });
            if (selectedListVariant === "All Spare Issue")
                spareIssuePagingAPICall({
                    request: _objectSpread({}, request)
                });
        },
        totalCount: crud === null || crud === void 0 || (_crud$SpareIssuesKeys4 = crud[SpareIssuesKeys.Paging]) === null || _crud$SpareIssuesKeys4 === void 0 ? void 0 : _crud$SpareIssuesKeys4.TotalCount,
        createButtonText: "New Spare Issue",
        isCreateButton: true,
        moduleName: "Spare Issue",
        onClickCreateModule: function () { return navigate("/spareIssues/createSpareIssues?mode=add"); }
    })), !isMobile && /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            color: 'secondary.200',
            width: "100%"
        }
    }), !isCardView && /*#__PURE__*/ React.createElement(Grid, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: SpareIssuesKeys.Paging,
        getPagingData: spareIssuePagingAPICall,
        pagingAPIRequest: _objectSpread({}, request),
        columns: customActionColumns,
        dataGridProps: {
            density: 'compact',
            initialState: {
                pinnedColumns: {
                    left: ['DocumentNo'],
                    right: ['StatusName', 'actions']
                }
            },
            onCellClick: function (params) {
                if (!(params.field == 'actions')) {
                    handleRowClick(params === null || params === void 0 ? void 0 : params.id);
                }
            },
            disableColumnMenu: false
        }
    })), isCardView && /*#__PURE__*/ React.createElement(InfiniteScroll, {
        pageSize: 1,
        apiCall: spareIssuePagingAPICall,
        apiKey: SpareIssuesKeys.Paging,
        apiRequest: _objectSpread({}, request),
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2,
            p: 2
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        },
        elements: cardElements
    }), isMobile && /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        bgcolor: "#F4F7FA",
        position: "fixed",
        bottom: 0,
        padding: 2,
        height: "69px",
        borderTop: '1px solid #DEE4EB',
        justifyContent: isMobile ? "center" : 'flex-end'
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        lg: 4,
        width: "80%"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        size: "small",
        color: "primary",
        id: "createspareIssueButton",
        onClick: onClickCreateModule,
        name: 'New Spare Issue',
        variant: "contained",
        fullWidth: true,
        sx: {
            padding: '8px 12px',
            justifyContent: 'center',
            fontWeight: 'medium'
        }
    }))), /*#__PURE__*/ React.createElement(Backdrop, {
        sx: function (theme) { return ({
            color: '#fff',
            zIndex: theme.zIndex.drawer + 1
        }); },
        open: Boolean(isLoadingState([SpareIssuesKeys.Paging]))
    }, /*#__PURE__*/ React.createElement(CircularProgress, {
        color: "inherit"
    })), /*#__PURE__*/ React.createElement(FilterComponent, {
        isFilterOpen: isFilterOpen,
        setFilterOpen: function (prev) { return setFilterOpen(prev); },
        selectedView: selectedListVariant
    }));
};
export default SpareIssues;
